import React from 'react'
import translations from './translations'

translations.add('pt', {
    iAgreeToShareWithClickToPay: (cardBrand) => <span>
        Eu concordo em partilhar os dados do meu cartão, morada de faturação e e-mail com o {cardBrand || 'Mastercard' } para permitir inscrever-me com segurança no <b>Click to Pay</b> para compras mais rápidas.
    </span>,
    learnMore: 'Saber mais'
})
